import { render, staticRenderFns } from "./part_life.vue?vue&type=template&id=7cdbd9ad&scoped=true"
import script from "./part_life.vue?vue&type=script&lang=js"
export * from "./part_life.vue?vue&type=script&lang=js"
import style0 from "./part_life.vue?vue&type=style&index=0&id=7cdbd9ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdbd9ad",
  null
  
)

export default component.exports